import { FunctionComponent } from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { CustomMenu } from "../CustomMenu";
import { IProps } from "./IProps";
import Icon from "@mdi/react";
import { mdiPencil, mdiAccountKeyOutline } from "@mdi/js";
import {
  mdiHomeVariantOutline,
  mdiAccountFilterOutline,
  mdiFolderOutline,
  mdiLinkBoxOutline,
} from "@mdi/js";
import { useUserNavMenu } from "./hook";
import { UserMenuLink } from "./type";
import { mapMenuToUserNavContent } from "../../utils/menu-utils";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

export const UserNavMenu: FunctionComponent<IProps> = (props): JSX.Element => {
  const { Logout, onChangePassword } = useUserNavMenu();
  const state = useSelector((state: RootState) => state.sidebar.items);
  const navigationItems = mapMenuToUserNavContent(state);

  const funcLinks = [
    {
      Icon: <Icon path={mdiAccountKeyOutline} />,
      label: "Reset Password",
      onClick: onChangePassword,
    },
    { Icon: <LogoutOutlinedIcon />, label: "Logout", onClick: Logout },
  ];

  return (
    <CustomMenu links={navigationItems} funcLinks={funcLinks} {...props} />
  );
};
